import { createApiModule, createQueryString } from 'api/common/utls';
import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from 'api/common/constants';

const FARM_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.FARM,
  false
);

// Define API methods
const apiMethods = {
  // Get dynamic farm form
  getFarmForm: (isEdit, id) => {
    // Ensure isEdit is a boolean
    const editMode = Boolean(isEdit);

    let queryParams = {
      // Convert boolean to string 'true' or 'false'
      is_edit: String(editMode)
    };

    if (!editMode) {
      queryParams.farmer_id = id;
    } else {
      queryParams.farm_id = id;
    }
    console.log(queryParams, id, 'queryParamsqueryParams');

    const queryString = createQueryString(queryParams);
    return apiClient.get(`${FARM_BASE}/form${queryString}`);
  },

  // Create farm
  createFarm: data => {
    return apiClient.post(FARM_BASE, data);
  },

  // Update farm
  updateFarm: (farmId, data) => {
    return apiClient.put(`${FARM_BASE}/${farmId}`, data);
  }
};

// Create API module with error handling
export const farmApi = createApiModule(apiMethods);

export const farmReportApi = {
  getDynamicFarmForm: (isEdit, id) => {
    if (!isEdit) {
      return apiClient.get(
        `${FARM_BASE}/form?is_edit=${isEdit}&farmer_id=${id}`
      );
    } else {
      return apiClient.get(`${FARM_BASE}/form?is_edit=${isEdit}&farm_id=${id}`);
    }
  },
  getEditFarmData: (tenantId, farmerId) =>
    apiClient.get(`${FARM_BASE}/${farmerId}`),

  submitFarm: (farmer_id, data) =>
    apiClient.post(`${FARM_BASE}/${farmer_id}`, data),

  submitEditFarm: (id, data) => apiClient.put(`${FARM_BASE}/${id}`, data)
};
